// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-pinch-view]{display:block;overflow:hidden;--scale:1;--x:0;--y:0}[data-pinch-view][data-pinch-view-mode=embed]{cursor:-webkit-grab;cursor:grab}[data-pinch-view][data-pinch-view-mode=embed]:active{cursor:-webkit-grabbing;cursor:grabbing}[data-pinch-view]>*{-webkit-transform:translate(var(--x),var(--y)) scale(var(--scale));transform:translate(var(--x),var(--y)) scale(var(--scale));-webkit-transform-origin:0 0;transform-origin:0 0;will-change:transform}", ""]);
// Exports
module.exports = exports;
